import Swiper, { Navigation, Pagination, Manipulation } from "swiper";

import { IContext } from "@src/context";
import { addFavoriteItem, removeFavoriteItem } from "@src/utils/favorite";
import { fetchFeaturedProperties } from "./fetch";
import { renderSlides } from "./slides";
import "./index.css";

export function setupFeaturedProperties(context: IContext) {
  const container = document.querySelector(".container-featured-properties");

  if (container == null) {
    return;
  }

  // init swiper
  const swiper = new Swiper(
    container.querySelector(
      ".container-featured-properties-swiper"
    ) as HTMLElement,
    {
      slidesPerView: 1,
      spaceBetween: 32,
      autoHeight: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1104: {
          slidesPerView: 2,
          spaceBetween: 56,
        },
      },
      modules: [Navigation, Pagination, Manipulation],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    }
  );

  // clear slides
  swiper.removeAllSlides();

  // add slides
  const containerId = container.getAttribute("data-container-id") || "";

  fetchFeaturedProperties(context, containerId).then((properties) => {
    const slides = renderSlides(context, properties);
    slides.forEach((slide) => {
      swiper.appendSlide(slide);
    });
  });

  // toggle favorite
  container.addEventListener("click", (event) => {
    if (event.target instanceof HTMLElement) {
      const btn = event.target.closest(
        ".container-featured-properties-item-favorite"
      );
      const propertyId = btn?.getAttribute("data-property-id");
      if (btn && propertyId) {
        if (btn.getAttribute("data-favorite") === "true") {
          // remove from favorite
          btn.setAttribute("data-favorite", "false");
          removeFavoriteItem(propertyId);
        } else {
          // add to favorite
          btn.setAttribute("data-favorite", "true");
          addFavoriteItem(propertyId);
        }
      }
    }
  });
}
